export default (function (value) {
  return value.toString();
});